var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UpcomingInvoicesList',{attrs:{"invoiceData":_vm.invoiceData,"totalDocs":_vm.totalDocs,"page":_vm.page,"noDataText":_vm.noDataText},on:{"getUpcomingInvoicesList":_vm.getUpcomingInvoicesList,"viewUpcomingInvoiceDetail":_vm.viewUpcomingInvoiceDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }